module.exports = __webpack_public_path__ + "img/Hotmart-5-pt.6a9fd2bf.png";